"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _mdiMaterialUi = require("mdi-material-ui");
var _reactSpring = require("react-spring");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _Modal = _interopRequireDefault(require("./Modal.styles"));
var _excluded = ["in", "children", "onEnter", "onExited"],
  _excluded2 = ["children", "title", "footerActions", "width", "open", "onClose", "onExited", "paperClasses", "showCloseButton"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Fade = /*#__PURE__*/(0, _react.forwardRef)(function Fade(props, ref) {
  var open = props.in,
    children = props.children,
    onEnter = props.onEnter,
    onExited = props.onExited,
    other = _objectWithoutProperties(props, _excluded);
  var style = (0, _reactSpring.useSpring)({
    from: {
      opacity: 0
    },
    to: {
      opacity: open ? 1 : 0
    },
    onStart: function onStart() {
      if (open && onEnter) {
        onEnter();
      }
    },
    onRest: function onRest() {
      if (!open && onExited) {
        onExited();
      }
    }
  });
  return /*#__PURE__*/_react.default.createElement(_reactSpring.animated.div, _extends({
    ref: ref,
    style: style
  }, other), children);
});
var Modal = function Modal(_ref) {
  var _classnames;
  var children = _ref.children,
    title = _ref.title,
    footerActions = _ref.footerActions,
    width = _ref.width,
    open = _ref.open,
    onClose = _ref.onClose,
    onExited = _ref.onExited,
    paperClasses = _ref.paperClasses,
    _ref$showCloseButton = _ref.showCloseButton,
    showCloseButton = _ref$showCloseButton === void 0 ? false : _ref$showCloseButton,
    props = _objectWithoutProperties(_ref, _excluded2);
  var classes = (0, _Modal.default)({
    showTitle: !!title
  });
  var cssModalDialog = (0, _classnames2.default)(classes.paper, (_classnames = {}, _defineProperty(_classnames, classes.widthSmall, width === 'small'), _defineProperty(_classnames, classes.widthMedium, width === 'medium'), _defineProperty(_classnames, classes.widthLarge, width === 'large'), _defineProperty(_classnames, classes.widthXLarge, width === 'xlarge'), _classnames), paperClasses);
  return /*#__PURE__*/_react.default.createElement(_core.Modal, _extends({
    "aria-labelledby": "spring-modal-title",
    "aria-describedby": "spring-modal-description",
    className: classes.modal,
    open: open,
    onClose: onClose,
    closeAfterTransition: true,
    BackdropComponent: _core.Backdrop,
    BackdropProps: {
      timeout: 500
    }
  }, props), /*#__PURE__*/_react.default.createElement(Fade, {
    className: classes.animatedDiv,
    in: open,
    onExited: onExited
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cssModalDialog
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.headerContainer
  }, /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement("h3", {
    className: classes.title
  }, title)), showCloseButton && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    disableRipple: true,
    onClick: onClose,
    className: classes.closeIcon
  }, /*#__PURE__*/_react.default.createElement(_mdiMaterialUi.Close, {
    fontSize: "small"
  })))), children, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.footerModal
  }, footerActions))));
};
var _default = Modal;
exports.default = _default;